import React, { useState } from 'react';
import { Input, InputGroup, InputRightElement, IconButton } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

const ClearableInput = ({
  value,
  onChange,
  onClearAgentOutput,
  onClearResearchReport,
  onClearVersionDropdown,
  ...props
}) => {
  const [isHovering, setIsHovering] = useState(false);

  const handleClear = () => {
    onChange('');
    onClearAgentOutput();
    onClearResearchReport();
    onClearVersionDropdown();
    
  };

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <InputGroup>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        pr="4.5rem"
        {...props}
      />
      {value.trim().length > 0 && (
        <InputRightElement width="4.5rem">
          <IconButton
            aria-label="Clear input"
            icon={<CloseIcon />}
            variant="ghost"
            h="1.75rem"
            size="sm"
            onClick={handleClear}
            opacity={isHovering ? 1 : 0.5}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
};

export default ClearableInput;